import React from "react";
import Speak from "./3rdretailicons7.svg";
import Searcher from "./3rdretailicons8.svg";
import Conect from "./3rdretailicons9.svg";

function Brands() {
  return (
    <div>
      <div
        className=" brand-bg-1"
        style={{
          backgroundImage: "url(./assets/media/illustrations/dots.png)",
          zIndex: "-1",
          backgroundAttachment: "fixed",
        }}
      >
        <div className="container">
          <div className="d-flex">
            <div className="min-h-350px min-h-lg-600px px-9">
              <div className="text-justify mb-2 mt-8 mb-lg-2 d-sm-block py-10 py-lg-20 ">
                <h4 className="fs-3x fs-lg-3x mb-2">
                  Brands Get Discovered<br></br> By Buyers And Grow Their{" "}
                  <br></br> Wholesale Business
                </h4>
                <div className="lineBefore mb-3"></div>
                <p className="my-12">
                  More than 50 manufacturers and suppliers trust 3rdretail for
                  <br></br> increased turnover. Harnessing swift distribution
                  chain,<br></br> brands are rest assured of global coverage to
                  meet their customers’ needs.
                </p>

                <div>
                  <div className="d-flex mb-5">
                    <img src={Speak} width="50px" height="50px" alt="vector1" />
                    <div className="flex-grow-1 ms-6">
                      <h5 className="fw-bolder">Find a Pitch</h5>
                      <p>
                        Find retailers from around the world and pitch your
                        Brand without the awkward cold calls or emails
                      </p>
                    </div>
                  </div>
                  <div className="d-flex my-7">
                    <img
                      src={Searcher}
                      width="50px"
                      height="50px"
                      alt="vector2"
                    />
                    <div className="flex-grow-1 ms-6">
                      <h5 className="fw-bolder">
                        Show up in thousands of Buyers' searches
                      </h5>
                      <p>
                        Put your best foot forward by telling your unique story
                        that will put you right in front of your searching
                        buyers
                      </p>
                    </div>
                  </div>
                  <div>
                    <div className="d-flex mt-7">
                      <img
                        src={Conect}
                        width="50px"
                        height="50px"
                        alt="vector3"
                      />
                      <div className="flex-grow-1 ms-6">
                        <h5 className="fw-bolder">
                          Real Buyers, Real Businesses
                        </h5>
                        <p>
                          Conduct seamless end-to-end trading with legitimate
                          businesses and ready buyers.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <a href="/Pagenotfound.html" className="btn btn-lg brandBtn">
                  Get Started
                </a>
              </div>
            </div>

            <div className="d-none d-lg-block">
              <img
                src={"./resources/img/brandimg.png"}
                className={"brandimg1"}
                alt="animate"
                width="950px"
                height="982px"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Brands;
